import Alpine from "alpinejs";
import Clipboard from "@ryangjchandler/alpine-clipboard";

Alpine.plugin(Clipboard);

window.Alpine = Alpine;
Alpine.start();

let notifyAppsBtn = document.getElementById("notify-apps");
if (notifyAppsBtn !== null) {
  notifyAppsBtn.addEventListener("click", async function() {
    // Make a GET request to /api/send-podping/{data-slug}. Record the response.
    let response = await fetch("/api/send-podping/" + this.dataset.slug);
    if (!response.ok) {
      let text = "Something went wrong.";
      if (response.body !== null) {
        text = await response.text();
      }
      alert(text);
      return;
    }

    notifyAppsBtn!.classList.remove("cursor-pointer");
    const textSpan = notifyAppsBtn!.querySelector("span")!;
    textSpan.innerHTML = "Notified!";
  });
}
